export async function getMatch(matchId) {
  const response = await fetch(`/api/matches/getMatch/${encodeURIComponent(matchId)}`);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    const err = new Error(`HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}
